import React from 'react';
import { styled } from '@compiled/react';
import Heading from '@atlaskit/heading';
import Lozenge from '@atlaskit/lozenge';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

export const RequestStatus = ({ source }: { source: Element }) => {
	let appearance = 'default';

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const tooltipTemp = document.createElement('span');
	tooltipTemp.innerHTML = source.getAttribute('data-tooltip') || '';

	if (source.classList.contains('jira-issue-status-lozenge-indeterminate')) {
		appearance = 'inprogress';
	} else if (source.classList.contains('jira-issue-status-lozenge-done')) {
		appearance = 'success';
	}

	const tooltipTitle = tooltipTemp.querySelector('.jira-issue-status-tooltip-title');
	const tooltipDesc = tooltipTemp.querySelector('.jira-issue-status-tooltip-desc');

	const tooltipContent = (
		<>
			{tooltipTitle && (
				<Heading size="small">
					{/* @ts-expect-error - TS2339 - Property 'innerText' does not exist on type 'Element'. */}
					<TooltipTitle>{tooltipTitle.innerText}</TooltipTitle>
				</Heading>
			)}
			{/* @ts-expect-error - TS2339 - Property 'innerText' does not exist on type 'Element'. */}
			{tooltipDesc && <TooltipDescription>{tooltipDesc.innerText}</TooltipDescription>}
		</>
	);

	return (
		<Tooltip content={tooltipContent} position="left">
			{/* @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ThemeAppearance | undefined'. */}
			<Lozenge appearance={appearance}>{source.textContent}</Lozenge>
		</Tooltip>
	);
};

// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TooltipTitle = styled.b({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.inverse', colors.N0),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TooltipDescription = styled.p({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.inverse', colors.N0),
	marginTop: token('space.100', '8px'),
	font: token('font.body'),
});
